import { render, staticRenderFns } from "./Freightlist.vue?vue&type=template&id=1cf253c7&scoped=true&"
import script from "./Freightlist.vue?vue&type=script&lang=js&"
export * from "./Freightlist.vue?vue&type=script&lang=js&"
import style0 from "./Freightlist.vue?vue&type=style&index=0&id=1cf253c7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cf253c7",
  null
  
)

export default component.exports